var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsString } from 'class-validator';
export class MessagingTemplateButtonDto {
    static fromKakaoTalkTemplateButton(kakaoButton) {
        var _a, _b, _c, _d;
        return {
            title: kakaoButton.name,
            link: kakaoButton.type === 'AL'
                ? ((_b = (_a = kakaoButton.iosAppLink) !== null && _a !== void 0 ? _a : kakaoButton.aosAppLink) !== null && _b !== void 0 ? _b : '')
                : ((_d = (_c = kakaoButton.pcWebLink) !== null && _c !== void 0 ? _c : kakaoButton.mobileWebLink) !== null && _d !== void 0 ? _d : ''),
        };
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], MessagingTemplateButtonDto.prototype, "title", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], MessagingTemplateButtonDto.prototype, "link", void 0);
